





























import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class extends Vue {
  // 接收参数
  @Prop() public data!: object[];
  public active: number = 0;
  get bgImg() {
    if ((this.data as any).platformList && (this.data as any).platformList.length) {
      return (this.data as any).platformList[this.active].imageUrl;
    }
    return '';
  }

  public handleClick(item: any, index: number) {
    this.active = index;
    // if (item.mode === 0) {
    //   this.ecologyBg = item.imageUrl;
    // } else
    if (item.mode === 1) {
      window.open(item.linkUrl);
    }
  }
}
